export function formatAnchorLinkId(id: string): string {
  // ID needs to start with a letter
  return `S${id.toLowerCase().slice(0, 6)}`;
}
